import React, { FC, ReactElement } from 'react';
import styles from './assets/password-recovery-screen.module.scss';
import classNames from 'classnames';
import { RouteComponentProps, withRouter } from 'react-router';

export interface StateProps {}
export interface DispatchProps {}
export interface OwnProps {}

interface RouteParams {}
export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

interface State {}

const IntakeParentSuccessScreen: FC<Props> = (props: Props) => {
    return (
        <div className={classNames(styles.loginWrapper)}>
            <div className={classNames('container')}>
                <div className={classNames(styles.passwordRecovery, 'py-3')}>
                    Thanks for your reply! The data was successfully sent.
                </div>
            </div>
        </div>
    );
};

export default IntakeParentSuccessScreen;
